export const defaultSteamModelForHydrogenPlants = '';
